import React from 'react';
import { Paper, Typography } from '@mui/material';

const DashboardCard = ({ title, value, icon: Icon, color = "#152d51" }) => (
  <Paper sx={{ p: 2.5, borderRadius: 3, boxShadow: 5 }}>
    <Typography variant="h6" sx={{ color, fontWeight: "bold", mb: 2 }}>
      <Icon sx={{ verticalAlign: "middle", marginRight: 1 }} />
      {title}
    </Typography>
    <Typography variant="h4" sx={{ color, fontWeight: "bold" }}>
      {value}
    </Typography>
  </Paper>
);

export default DashboardCard;